import { Helmet } from 'react-helmet'
import InspirationBanner from '../assets/landing/InspirationBanner.webp'
import InspirationBannerMobile from '../assets/landing/InspirationBannerMobile.webp'
import IdeaBanner from '../assets/landing/IdeaBanner.webp'
import IdeaBannerMobile from '../assets/landing/IdeaBannerMobile.webp'
import { Button } from 'react-bootstrap'
import { useContext, useState } from 'react'
import classNames from 'classnames'
import YoutubeEmbed from '../components/YoutubeEmbed'
import { useMediaQuery } from '@uidotdev/usehooks'
import { ideasList } from '../constants/Ideas.js'
import InstagramEmbed from '../components/InstagramEmbed.jsx'
import { AppContext } from '../context/index.js'

const Inspiration = () => {
  const [idea, setIdea] = useState('')
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const isMobile = useMediaQuery('(max-width: 768px)')
  const { competitionInfo } = useContext(AppContext)

  const generateRandomIdea = () => {
    const randomIndex = Math.floor(Math.random() * ideasList.length)
    setIdea(ideasList[randomIndex])
    setButtonDisabled(true)

    setTimeout(() => {
      setButtonDisabled(false)
    }, 2000)

    setTimeout(() => {
      setIdea('')
    }, 15000)
  }

  const handleVideo = () => {
    if (
      !competitionInfo ||
      !competitionInfo.competition ||
      !competitionInfo.competition.video_example ||
      !competitionInfo.competition.video_example.hosted_in ||
      !competitionInfo.competition.video_example.video_link
    ) {
      return <p>No video available</p>
    }

    const { hosted_in, video_link } = competitionInfo.competition.video_example

    switch (hosted_in) {
    case 'Youtube':
      return <YoutubeEmbed video={video_link} className="HowToEnter__Video" />
    case 'TikTok':
      return (
        <div
          style={{
            left: 0,
            width: '100%',
            height: 738,
            position: 'relative',
          }}
        >
          <iframe
            style={{
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              position: 'absolute',
              border: 0,
            }}
            className="embed-responsive-item"
            src={video_link}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded video"
          />
        </div>
      )
    case 'Instagram':
      return <InstagramEmbed videoSrc={video_link} />
    default:
      return <></>
    }
  }

  return (
    <main>
      <Helmet>
        <title>Be inspired | RFDS (Queensland Section) + Elders</title>
      </Helmet>
      <section className="Inspiration__Banner">
        <img
          className="Inspiration__Banner__Image"
          src={isMobile ? InspirationBannerMobile : InspirationBanner}
          alt="bannerBackground"
        />
        <p className='text-center'>Be inspired</p>
      </section>
      <section className="Inspiration__Texts">
        <div className="d-flex flex-column justify-content-center w-100 gap-4" style={{ maxWidth: '700px' }}>
          <p className="caption-2">Need some inspo? You’ve come to the right place.</p>
          <p className="ffam-FreeSans text-3">
            Not sure what to film for your Outback Explorer Competition entry? No worries! We’ve got some ideas for you.
          </p>
          <p className="ffam-FreeSans text-3">
            There’s plenty of stories waiting to be told—from dusty road trips and sunset paddocks to busy work days and quiet coffee breaks. Whether you’re heading to work, hanging with mates, or hitting the trails, we want to see what life looks like through your lens.
          </p>
          <p className="ffam-FreeSans text-3">
            So, think about what makes your day yours—and capture it. Big moments, small rituals, and everything in between.
          </p>
          <p className="ffam-FreeSans text-3">
            Get inspired, hit record, and show us your life in regional Queensland for the chance to win $10,000 cash.
          </p>
        </div>
      </section>
      <section className="Inspiration__Banner" style={{ padding: '0 16px' }}>
        <img className="Inspiration__Banner__Image2" src={isMobile ? IdeaBannerMobile : IdeaBanner} alt="bannerBackground" />
        <div className='Inspiration__Banner__Container'>
          <p className='text-center mt-4 mt-lg-0'>Still stuck for ideas?</p>
          <Button variant='rs' onClick={generateRandomIdea} style={{ width: 'max-content' }} disabled={buttonDisabled}>
            Generate idea
          </Button>
          <div
            className={classNames('Inspiration__Form mb-4 mb-lg-0', {
              'HasIdea': idea,
            })}
          >
            {idea ? idea : 'Click on the above button to generate an idea!'}
          </div>
        </div>
      </section>
      <section className="Inspiration__Video">
        <div className="Inspiration__Video__Container">
          <p className="caption-2">Watch our example video!</p>
          {handleVideo()}
        </div>
      </section>
    </main>
  )
}

export default Inspiration